import FormattedMessage from 'I18n/components/FormattedMessage';
import { TAG_MANAGER_TABLE_COLUMNS } from '../../../constants/manageTags';
import { jsx as _jsx } from "react/jsx-runtime";
const TagManagerTableHeader = () => {
  const getColumnHeader = ({
    key,
    labelKey
  }) => {
    if (!labelKey) {
      return /*#__PURE__*/_jsx("th", {}, key);
    }
    return /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: labelKey
      })
    }, key);
  };
  return /*#__PURE__*/_jsx("thead", {
    children: /*#__PURE__*/_jsx("tr", {
      children: TAG_MANAGER_TABLE_COLUMNS.map(columnData => getColumnHeader(columnData))
    })
  });
};
export default TagManagerTableHeader;